export const FEDRAMP_MODERATE = 'fedramp-moderate';
export const COMMERCIAL = 'commercial';
export const FEDRAMP_FEDEX = 'fedramp-fedex';
export const STAGING = 'stg';
export const PRODUCTION = 'prod';
export const DEV = 'dev';